export default __webpack_public_path__ + "static/media/planCardBg.85c9d549.png";